import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getAppointmentTimeslotsNewRequest: ["children_id"],
  getAppointmentTimeslotsNewSuccess: ["timeslots"],
  getAppointmentTimeslotsNewFailure: null,
});

export const GetAppointmentTimeslotsNewTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  children_id: null,
  fetching: null,
  success: null,
  timeslots: null,
  error: null,
});

export const GetAppointmentTimeslotsNewSelectors = {
  getData: (state: any) => state.getAppointmentTimeslotsNew.data,
  isFetching: (state: any) => state.getAppointmentTimeslotsNew.fetching,
  isSuccess: (state: any) => state.getAppointmentTimeslotsNew.success,
  hasError: (state: any) => state.getAppointmentTimeslotsNew.error,
};

export const request = (state: any, { children_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    children_id,
    timeslots: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { timeslots } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    timeslots,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    timeslots: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_APPOINTMENT_TIMESLOTS_NEW_REQUEST]: request,
  [Types.GET_APPOINTMENT_TIMESLOTS_NEW_SUCCESS]: success,
  [Types.GET_APPOINTMENT_TIMESLOTS_NEW_FAILURE]: failure,
});
